import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

export const MandalaGenesis: React.FC<{ opacity?: number }> = ({ opacity = 1 }) => {
  const frame = useCurrentFrame();
  const rings = 6;
  const petalsPerRing = [6, 8, 12, 16, 20, 24];

  return (
    <AbsoluteFill style={{ opacity, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg viewBox="-200 -200 400 400" width="80%" height="80%" style={{ position: "absolute" }}>
        {Array.from({ length: rings }, (_, ringIdx) => {
          const radius = 25 + ringIdx * 28;
          const petals = petalsPerRing[ringIdx];
          const ringDelay = ringIdx * 15;
          const ringProgress = interpolate(frame, [ringDelay, ringDelay + 40], [0, 1], {
            extrapolateLeft: "clamp", extrapolateRight: "clamp",
          });
          const rotation = (frame * 0.15 * (ringIdx % 2 === 0 ? 1 : -1));

          return (
            <g key={ringIdx} transform={`rotate(${rotation})`} opacity={ringProgress}>
              {/* Ring circle */}
              <circle cx={0} cy={0} r={radius} fill="none"
                stroke="#D4A843" strokeWidth={0.5} opacity={0.3 * ringProgress}
                strokeDasharray={`${2 * Math.PI * radius}`}
                strokeDashoffset={`${2 * Math.PI * radius * (1 - ringProgress)}`}
              />
              {/* Petals */}
              {Array.from({ length: petals }, (_, petalIdx) => {
                const angle = (petalIdx / petals) * 360;
                const petalDelay = ringDelay + petalIdx * 2;
                const petalProgress = interpolate(frame, [petalDelay, petalDelay + 20], [0, 1], {
                  extrapolateLeft: "clamp", extrapolateRight: "clamp",
                });
                return (
                  <ellipse
                    key={petalIdx}
                    cx={radius * Math.cos((angle * Math.PI) / 180)}
                    cy={radius * Math.sin((angle * Math.PI) / 180)}
                    rx={8 * petalProgress}
                    ry={4 * petalProgress}
                    transform={`rotate(${angle}, ${radius * Math.cos((angle * Math.PI) / 180)}, ${radius * Math.sin((angle * Math.PI) / 180)})`}
                    fill="none"
                    stroke={ringIdx % 2 === 0 ? "#F37021" : "#D4A843"}
                    strokeWidth={0.8}
                    opacity={petalProgress * 0.7}
                  />
                );
              })}
            </g>
          );
        })}
        {/* Center glow */}
        <circle cx={0} cy={0} r={interpolate(frame, [0, 30], [0, 12], { extrapolateRight: "clamp" })}
          fill="#D4A843" opacity={0.4 + Math.sin(frame / 30) * 0.15}
        />
      </svg>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
